import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const SupportCardRoot = superstyled({
  name: 'SupportCard',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  })
});

export const SupportCardSection = superstyled({
  name: 'SupportCard',
  slot: 'Section',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4),
    boxShadow: theme.shadows[1]
  })
});

export const SupportCardSectionTitle = superstyled({
  name: 'SupportCard',
  slot: 'SectionTitle',
  tag: Text,
  styles: () => ({
    // marginBottom: theme.spacing(2)
  })
});

export const SupportCardDescription = superstyled({
  name: 'SupportCard',
  slot: 'Description',
  tag: Text,
  styles: () => ({
    // marginBottom: theme.spacing(3)
  })
});

export const SupportCardButton = superstyled({
  name: 'SupportCard',
  slot: 'Button',
  tag: Button,
  styles: ({ theme }) => ({
    alignSelf: 'flex-start',
    color: '#3971E7' || `${theme.palette.background.blue.main}`
  })
});
